export const DEFAULT_LOAD_MORE_BUTTON_TEXT = "LOAD {{number}} MORE";
export const DEFAULT_PROGRESS_BAR_TEXT =
  "You've viewed {{number}} of {{number}} items";
